export default __webpack_public_path__ + "static/media/Banners_cybermonday_gmm_330x330.626cb71c.jpg";